// 导出比价信息
import store from '@/store'
import { addQueryToUrl } from '@/utils/utils'
import { workbenchServiceDict } from '@/dictionary/system'
const baseUrl = process.env.VUE_APP_PURCHASE_API

const tempArray = workbenchServiceDict.array

function getPlatformAlias() {
  return tempArray.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

// 招标-获取结果通知书信息
export function getWinBidResultInfoApi(query) {
  const alias = getPlatformAlias()
  return (
    baseUrl +
    `/workbench/supplier/bidding-orders/${query.orderId}/download-result-pdf/${query.tradeId}?type=1&winnerStatus=${query.winnerStatus}&winnerId=${query.winnerId}&identity=${alias}`
  )
}

// 询比-导出全部比价(v2，针对个性化需求开发)
export function exportAllOfferApi(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/inquiry-orders/export/v2/all-offer`,
      { ...params, identity: getPlatformAlias() }
    )
  )
}

// 询比-导出比价表
export function exportCompareInfoApi(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/inquiry-orders/export/all-offer`,
      { ...params, identity: getPlatformAlias() }
    )
  )
}

// 询比-导出全部比价(v3，针对个性化需求开发)
export function exportAllOfferV3Api(params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/inquiry-orders/export/v3/all-offer`,
      { ...params, identity: getPlatformAlias() }
    )
  )
}

// 询比-下载报价信息
export function downloadQuoteInfo(ids, isNoRateOffer) {
  const { orderId, tradeId, roundId } = ids
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/supplier/inquiry-orders/export/${orderId}/trades/${tradeId}/rounds/${roundId}`,
      { isNoRateOffer, identity: getPlatformAlias() }
    )
  )
}

// 询比-结果通知书预览和下载
export function getWinnerFileApi(ids) {
  const { orderId, tradeId, tradeResultId } = ids
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/result-pdf`,
      { tradeResultId, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 竞价-下载和预览成交供应商
export function downloadResultApi(orderId, tradeId) {
  window.open(
    addQueryToUrl(
      `${process.env.VUE_APP_PURCHASE_API}/workbench/supplier/competition-orders/${orderId}/trades/${tradeId}/result-pdf`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 采购人收入账单导出
export function exportRevenueListApi(params) {
  const keys = Object.keys(params)
  let paramsStr = ''
  keys.forEach(key => {
    if (params[key]) {
      paramsStr += `${key}=${params[key]}&`
    }
  })
  paramsStr = paramsStr.substring(0, paramsStr.lastIndexOf('&'))
  return paramsStr
    ? `${process.env.VUE_APP_PAY_API}/v1/order/export?${paramsStr}`
    : `${process.env.VUE_APP_PAY_API}/v1/order/export`
}

// 采购人发票管理导出
export function exportInvoiceListApi(params) {
  const keys = Object.keys(params)
  let paramsStr = ''
  keys.forEach(key => {
    if (params[key]) {
      paramsStr += `${key}=${params[key]}&`
    }
  })
  paramsStr = paramsStr.substring(0, paramsStr.lastIndexOf('&'))
  return paramsStr
    ? `${process.env.VUE_APP_PAY_API}/v1/invoiceApply/export?${paramsStr}`
    : `${process.env.VUE_APP_PAY_API}/v1/invoiceApply/export`
}

// 下载供应商的证件列表-招标-业务
export function downloadWorkbenchBidSupplierRequireFileApi(orderId, tradeId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/bidding-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载供应商的证件列表-招标-统计
export function downloadMonitorBidSupplierRequireFileApi(orderId, tradeId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/bidding-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载供应商的证件列表-询比-业务
export function downloadWorkbenchInquirySupplierRequireFileApi(
  orderId,
  tradeId
) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/inquiry-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载供应商的证件列表-询比-统计
export function downloadMonitorInquirySupplierRequireFileApi(orderId, tradeId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/inquiry-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载供应商的证件列表-竞价-业务
export function downloadWorkbenchCompeteSupplierRequireFileApi(
  orderId,
  tradeId
) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/competition-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载供应商的证件列表-竞价-统计
export function downloadMonitorCompeteSupplierRequireFileApi(orderId, tradeId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/monitor/project/competition-orders/${orderId}/trades/${tradeId}/cert-require/download`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/**
 * 招标单报名分页列表导出
 * @param {number} orderId
 * @param {Object} params
 * @returns {string}
 */
export function downloadBidSignUpListApi(orderId, params) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/bidding-orders/${orderId}/export/sign-up`,
      { ...params, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/**
 * 竞价单报名分页列表导出
 * @param {number} orderId
 * @returns {string}
 */
export function downloadCompeteSignUpListApi(orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/competition-orders/${orderId}/trades/export`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/**
 * 下载合并后的评标报告
 */
export function downloadMergeReviewReportApi(
  projectId,
  processId,
  reportId,
  catalogIds
) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/catalogs/merge`,
      { identity: getPlatformAlias(), catalogIds }
    ),
    '_blank'
  )
}

// 询比-成交结果通知书下载
export function getInquiryWinnerNoticeFileApi(ids) {
  const { orderId, tradeId, winnerId } = ids
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/inquiry-orders/${orderId}/winners/${winnerId}/result-pdf`,
      { tradeId, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}
